import * as React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { StyledColumnBox, StyledModalTitle } from '../../theme/StyledElements';
import { useEffect, useState } from 'react';
import { SalesTableViewData } from '../../models/SalesTableViewData';

interface ClientDetailsHeaderProps {
    salesData: SalesTableViewData;
}

export function ClientDetailsHeader({ salesData }: ClientDetailsHeaderProps): JSX.Element {
    const { t } = useTranslation();
    const [salesDetails, setSalesDetails] = useState<SalesTableViewData>(salesData);

    useEffect(() => {
        if (salesData) {
            setSalesDetails(salesData);
        }
    }, [salesData]);

    return (
        <StyledModalTitle>
            <StyledColumnBox
                sx={{
                    textAlign: 'left',
                    marginRight: '20px'
                }}>
                <Typography variant="body1" color="#FFFFFF">
                    {t('number')} : {salesDetails.orderNumber}
                </Typography>
                <Typography variant="body1" color="#FFFFFF">
                    {t('date')} : {salesDetails.date}
                </Typography>
            </StyledColumnBox>
            <StyledColumnBox sx={{ textAlign: 'left', marginRight: '20px' }}>
                <Typography variant="body1" color="#FFFFFF">
                    {t('noOfBaskets')} : {salesDetails.noOfBaskets}
                </Typography>
                <Typography variant="body1" color="#FFFFFF">
                    {t('turnOver')} : {salesDetails.cost?.toFixed(2)}€
                </Typography>
            </StyledColumnBox>
            <Typography
                variant="body1"
                color="#FFFFFF"
                sx={{ textAlign: 'left', marginRight: '20px' }}>
                {t('status')} : {salesDetails.status}
            </Typography>
        </StyledModalTitle>
    );
}
